/**
 * Página de configuración del profesor
 */

import React from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { ProfesorLayout } from "../components";

export const ProfesorConfiguracionPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <ProfesorLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header mejorado */}
        <div className="mb-10">
          <div className="bg-gradient-to-r from-purple-600 to-purple-800 rounded-xl shadow-lg p-8 text-white">
            <h1 className="text-4xl font-bold mb-2">Configuración</h1>
            <p className="text-purple-100 text-lg">
              Administra tus preferencias y datos personales
            </p>
          </div>
        </div>

        {/* Información Personal */}
        <div className="bg-white shadow-xl rounded-xl overflow-hidden border border-gray-100 mb-6">
          <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
              <svg
                className="w-6 h-6 text-purple-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              Información Personal
            </h2>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-1">
                <label className="block text-sm font-semibold text-gray-600 uppercase tracking-wide">
                  Nombre Completo
                </label>
                <div className="mt-2 p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-lg font-semibold text-gray-900">
                    {user?.nombres} {user?.apellidos}
                  </p>
                </div>
              </div>

              <div className="space-y-1">
                <label className="block text-sm font-semibold text-gray-600 uppercase tracking-wide">
                  Email
                </label>
                <div className="mt-2 p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-lg font-semibold text-gray-900">
                    {user?.email}
                  </p>
                </div>
              </div>

              <div className="space-y-1">
                <label className="block text-sm font-semibold text-gray-600 uppercase tracking-wide">
                  Rol
                </label>
                <div className="mt-2 p-4 bg-purple-50 rounded-lg border border-purple-200">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-purple-100 text-purple-800">
                    {user?.rol}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Preferencias */}
        <div className="bg-white shadow-xl rounded-xl overflow-hidden border border-gray-100">
          <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
              <svg
                className="w-6 h-6 text-purple-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              Preferencias
            </h2>
          </div>
          <div className="p-6">
            <p className="text-gray-500 text-center py-8">
              Las opciones de preferencias estarán disponibles próximamente
            </p>
          </div>
        </div>
      </div>
    </ProfesorLayout>
  );
};
